import { BankProvider, BankConnectionType } from '@/types/bank';
import i18next from '@/lang/i18n';
import StripeLogo from '@/assets/images/banks/stripe.svg?react';
import RevolutLogo from '@/assets/images/banks/revolut.svg?react';
import PayseraLogo from '@/assets/images/banks/paysera.svg?react';
import LHVLogo from '@/assets/images/banks/LHV.svg?react';
import PaypalLogo from '@/assets/images/banks/paypal.svg?react';
import BitcoinLogo from '@/assets/images/banks/bitcoin.svg?react';
import LitecoinLogo from '@/assets/images/banks/litecoin.svg?react';
import BitcoinCashLogo from '@/assets/images/banks/bitcoin_cash.svg?react';
import EthereumLogo from '@/assets/images/banks/ethereum.svg?react';
import SolanaLogo from '@/assets/images/banks/solana.svg?react';
import RippleLogo from '@/assets/images/banks/ripple.svg?react';
import MollieLogo from '@/assets/images/banks/mollie.svg?react';
import WiseLogo from '@/assets/images/banks/wise.svg?react';
import PayoneerLogo from '@/assets/images/banks/payoneer.svg?react';
import SwedbankLogo from '@/assets/images/banks/swedbank.svg?react';
import SEBLogo from '@/assets/images/banks/SEB.svg?react';
import KrakenLogo from '@/assets/images/banks/kraken.svg?react';
import InteractiveBrokersLogo from '@/assets/images/banks/interactive_brokers.svg?react';
import BinanceLogo from '@/assets/images/banks/binance.svg?react';

export const BANK_TYPE_TRANSFERWISE = 'transferwise';
export const BANK_TYPE_REVOLUT_BUSINESS = 'revolut_business';
export const BANK_TYPE_PAYSERA = 'paysera';
export const BANK_TYPE_HOLVI = 'holvi';
export const BANK_TYPE_KRAKEN = 'kraken';
export const BANK_TYPE_BINANCE = 'binance';
export const BANK_TYPE_INTERACTIVE_BROKERS = 'interactive_brokers';
export const BANK_TYPE_LEO_PAY = 'leopay';
export const BANK_TYPE_PAYPAL = 'paypal';
export const BANK_TYPE_LHV = 'lhv';
export const BANK_TYPE_STRIPE = 'stripe';
export const BANK_TYPE_MISTER_TANGO = 'mister_tango';
export const BANK_TYPE_MOLLIE = 'mollie';
export const BANK_TYPE_SEB = 'seb';
export const BANK_TYPE_SWEDBANK = 'swedbank';
export const BANK_TYPE_CASHAA = 'cashaa';
export const BANK_TYPE_PAYONEER = 'payoneer';
export const BANK_TYPE_PAXUM = 'paxum';
export const BANK_TYPE_DECTA = 'decta';
export const BANK_TYPE_CUSTOM = 'custom';
export const BANK_TYPE_BITCOIN = 'bitcoin';
export const BANK_TYPE_LITECOIN = 'litecoin';
export const BANK_TYPE_ETHEREUM = 'ethereum';
export const BANK_TYPE_BITCOIN_CASH = 'bitcoin_cash';
export const BANK_TYPE_SOLANA = 'solana';
export const BANK_TYPE_RIPPLE = 'ripple';
export const BANK_TYPE_ERC20 = 'erc20';
export const TOKEN_TYPE_NATIVE = 'native';
export const TOKEN_TYPE_ERC20 = 'ERC-20';
export const BANK_TYPE_WISE = 'WISE_TRWIGB22';
export const BANK_TYPE_PAYONEER_API = 'payoneer_api';
export const LHV_LHVBEE22 = 'LHV_LHVBEE22';

export const ALL_BANKS = [
  BANK_TYPE_TRANSFERWISE,
  BANK_TYPE_REVOLUT_BUSINESS,
  BANK_TYPE_PAYSERA,
  BANK_TYPE_HOLVI,
  BANK_TYPE_KRAKEN,
  BANK_TYPE_BINANCE,
  BANK_TYPE_INTERACTIVE_BROKERS,
  BANK_TYPE_LEO_PAY,
  BANK_TYPE_PAYPAL,
  BANK_TYPE_LHV,
  BANK_TYPE_STRIPE,
  BANK_TYPE_MISTER_TANGO,
  BANK_TYPE_MOLLIE,
  BANK_TYPE_SEB,
  BANK_TYPE_SWEDBANK,
  BANK_TYPE_CASHAA,
  BANK_TYPE_PAYONEER,
  BANK_TYPE_PAXUM,
  BANK_TYPE_DECTA,
  BANK_TYPE_BITCOIN,
  BANK_TYPE_LITECOIN,
  BANK_TYPE_ETHEREUM,
  BANK_TYPE_BITCOIN_CASH,
  BANK_TYPE_SOLANA,
  BANK_TYPE_RIPPLE,
  BANK_TYPE_ERC20
];

export const OLD_NON_LINKABLE_BANKS = [
  BANK_TYPE_REVOLUT_BUSINESS,
  BANK_TYPE_PAYSERA,
  BANK_TYPE_HOLVI,
  BANK_TYPE_KRAKEN,
  BANK_TYPE_INTERACTIVE_BROKERS,
  BANK_TYPE_LEO_PAY,
  BANK_TYPE_PAYPAL,
  BANK_TYPE_MISTER_TANGO,
  BANK_TYPE_SEB,
  BANK_TYPE_SWEDBANK,
  BANK_TYPE_CASHAA,
  BANK_TYPE_PAXUM,
  BANK_TYPE_DECTA,
  BANK_TYPE_CUSTOM
];

export const CRYPTO_BANKS = [
  BANK_TYPE_BITCOIN,
  BANK_TYPE_LITECOIN,
  BANK_TYPE_ETHEREUM,
  BANK_TYPE_BITCOIN_CASH,
  BANK_TYPE_SOLANA,
  BANK_TYPE_RIPPLE,
  BANK_TYPE_ERC20
];

export const OLD_LINKABLE_BANKS = [
  BANK_TYPE_TRANSFERWISE,
  BANK_TYPE_LHV,
  BANK_TYPE_STRIPE,
  BANK_TYPE_MOLLIE
];

export const BANKS_WITHOUT_INTEGRATION = [
  BANK_TYPE_REVOLUT_BUSINESS,
  BANK_TYPE_PAYSERA,
  BANK_TYPE_HOLVI,
  BANK_TYPE_LEO_PAY,
  BANK_TYPE_PAYPAL,
  BANK_TYPE_MISTER_TANGO,
  BANK_TYPE_SEB,
  BANK_TYPE_SWEDBANK,
  BANK_TYPE_CASHAA,
  BANK_TYPE_DECTA,
  BANK_TYPE_CUSTOM,
  BANK_TYPE_TRANSFERWISE,
  BANK_TYPE_PAYONEER,
  BANK_TYPE_LHV,
  BANK_TYPE_STRIPE,
  BANK_TYPE_INTERACTIVE_BROKERS,
  BANK_TYPE_PAXUM
];

export const MANUAL_BANKS: string[] = [];

// IBRIT tokens have a ~10y expiry and no periodic PSD2 re-consent, so IB never
// needs the Nordigen/OAuth reconnect flow. The Reconnect affordance is hidden;
// if a token is invalidated the user deletes and reconnects fresh.
export const NO_RECONNECT_BANKS = [BANK_TYPE_INTERACTIVE_BROKERS];

// Exchanges connected via read-only API key. They have no reconnection flow:
// once the key is added there is nothing to re-authorize, so Reconnect must be hidden.
export const EXCHANGE_API_BANKS = [BANK_TYPE_BINANCE, BANK_TYPE_KRAKEN];

// Bank providers hidden from the customer dashboard connect flow ONLY. The backend
// and admin keep the integration; this just removes the card from the Add-Bank screen.
export const DISABLED_BANK_PROVIDERS = [BANK_TYPE_BINANCE];

export const BANK_PROVIDERS = Object.freeze<BankProvider[]>([
  {
    id: 'STRIPE_STPUIE21',
    bankType: BANK_TYPE_STRIPE,
    logo: StripeLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Stripe' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isPopular: true,
    isRecommended: true
  },
  {
    id: 'LHV_LHVBEE22',
    bankType: BANK_TYPE_LHV,
    logo: LHVLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'LHV' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isPopular: true,
    referralLink: 'mailto:benjamin.siiman@lhv.ee',
    isRecommended: true
  },
  {
    id: 'WISE_TRWIGB22',
    bankType: BANK_TYPE_TRANSFERWISE,
    logo: WiseLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Wise' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    referralLink: 'https://wi.se/companio',
    isPopular: true,
    isRecommended: true
  },
  {
    id: 'REVOLUT_REVOLT21',
    bankType: BANK_TYPE_REVOLUT_BUSINESS,
    logo: RevolutLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Revolut' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isPopular: true
  },
  {
    id: 'PAYPAL_PPLXLULL',
    bankType: BANK_TYPE_PAYPAL,
    logo: PaypalLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Paypal' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isPopular: true
  },
  {
    id: BANK_TYPE_BITCOIN,
    bankType: BANK_TYPE_BITCOIN,
    logo: BitcoinLogo,
    description: i18next.t('bank_provider_description_crypto_wallet'),
    connectionType: BankConnectionType.CRYPTO,
    isRecommended: true
  },
  {
    id: BANK_TYPE_ETHEREUM,
    bankType: BANK_TYPE_ETHEREUM,
    logo: EthereumLogo,
    description: i18next.t('bank_provider_description_crypto_wallet'),
    connectionType: BankConnectionType.CRYPTO,
    isRecommended: true
  },
  {
    id: BANK_TYPE_LITECOIN,
    bankType: BANK_TYPE_LITECOIN,
    logo: LitecoinLogo,
    description: i18next.t('bank_provider_description_crypto_wallet'),
    connectionType: BankConnectionType.CRYPTO,
    isRecommended: true
  },
  {
    id: BANK_TYPE_BITCOIN_CASH,
    bankType: BANK_TYPE_BITCOIN_CASH,
    logo: BitcoinCashLogo,
    description: i18next.t('bank_provider_description_crypto_wallet'),
    connectionType: BankConnectionType.CRYPTO,
    isRecommended: true
  },
  {
    id: BANK_TYPE_SOLANA,
    bankType: BANK_TYPE_SOLANA,
    logo: SolanaLogo,
    description: i18next.t('bank_provider_description_crypto_wallet'),
    connectionType: BankConnectionType.CRYPTO,
    isRecommended: true
  },
  {
    id: BANK_TYPE_RIPPLE,
    bankType: BANK_TYPE_RIPPLE,
    logo: RippleLogo,
    description: i18next.t('bank_provider_description_crypto_wallet'),
    connectionType: BankConnectionType.CRYPTO,
    isRecommended: true
  },
  {
    id: BANK_TYPE_MOLLIE,
    bankType: BANK_TYPE_MOLLIE,
    logo: MollieLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Mollie' }),
    connectionType: BankConnectionType.API,
    isOther: true
  },
  {
    id: BANK_TYPE_PAYONEER,
    bankType: BANK_TYPE_PAYONEER,
    logo: PayoneerLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', {
      bank: 'Payoneer'
    }),
    connectionType: BankConnectionType.LINK,
    referralLink: 'http://tracking.payoneer.com/aff_c?offer_id=507&aff_id=44066&url_id=1077',
    isOther: true
  },
  {
    id: 'PAYSERA_EVIULT21XXX',
    bankType: BANK_TYPE_PAYSERA,
    logo: PayseraLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Paysera' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isOther: true
  },
  {
    id: 'SWEDBANK_HABAEE2X',
    bankType: BANK_TYPE_SWEDBANK,
    logo: SwedbankLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', {
      bank: 'Swedbank'
    }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isOther: true
  },
  {
    id: 'SEB_EEUHEE2X',
    bankType: BANK_TYPE_SEB,
    logo: SEBLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'SEB' }),
    connectionType: BankConnectionType.OPEN_BANKING,
    isOther: true
  },
  {
    id: BANK_TYPE_KRAKEN,
    bankType: BANK_TYPE_KRAKEN,
    logo: KrakenLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', { bank: 'Kraken' }),
    // OAuth is not functional/provisioned on Kraken's side yet → use API key + secret.
    // Flip back to BankConnectionType.LINK to re-enable the (dormant) OAuth flow.
    connectionType: BankConnectionType.EXCHANGE_API,
    isOther: true
  },
  {
    id: BANK_TYPE_BINANCE,
    bankType: BANK_TYPE_BINANCE,
    logo: BinanceLogo,
    description: i18next.t('bank_provider_description_exchange_api', { bank: 'Binance' }),
    connectionType: BankConnectionType.EXCHANGE_API,
    isOther: true
  },
  {
    id: BANK_TYPE_INTERACTIVE_BROKERS,
    bankType: BANK_TYPE_INTERACTIVE_BROKERS,
    logo: InteractiveBrokersLogo,
    description: i18next.t('bank_provider_description_allows_bank_statements', {
      bank: 'Interactive Brokers'
    }),
    connectionType: BankConnectionType.IBRIT,
    isOther: true
  }
]);

export const BANKS_AVAILABLE_FOR_PRO_PLAN = 3;
export const BANKS_AVAILABLE_FOR_PREMIUM_PLAN = 5;

export const UPGRADE_PLAN_CONFIG: Record<
  'ultra' | 'premium',
  { plan: string; title: string; description: string }
> = {
  premium: {
    plan: 'premium',
    title: 'upload_statement_premium_upgrade_title',
    description: 'add_new_bank_premium_upgrade_description'
  },
  ultra: {
    plan: 'ultra',
    title: 'add_new_bank_ultra_upgrade_title',
    description: 'add_new_bank_ultra_upgrade_description'
  }
};

export const BANK_ACCOUNT_BALANCE_TYPE_SVGS = 'SVGS';
export const BANK_ACCOUNT_BALANCE_TYPE_LLSV = 'LLSV';
